import React from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { WorkTagData } from '../../shared/dto/EntityRepository';
import { useWorkViewStore } from '../../shared/store/WorkViewStore';

interface WorkTagInViewerProps {
  tag: WorkTagData;
}

const WorkTagInViewer: React.FC<WorkTagInViewerProps> = ({ tag }) => {
  const { isEditMode } = useEditMode();
  const activeWork = useWorkViewStore((s) => s.activeWork);
  const updateActiveWork = useWorkViewStore((s) => s.updateActiveWork);
  if (!activeWork) return null;
  
  const currentTags = activeWork.tags ?? [];
  const isOnWork = currentTags.some((t) => t.id === tag.id);
  
  if (!isEditMode && !isOnWork) return null;

  const handleToggle = () => {
    if (!isEditMode) {
      return;
    }
    const nextTags = isOnWork
      ? currentTags.filter((t) => t.id !== tag.id)
      : [...currentTags, tag];
    updateActiveWork({ tags: nextTags });
  };

  return (
    <TagItem $isActive={isOnWork} $isEditMode={isEditMode} onClick={handleToggle}>
      {tag.name}
    </TagItem>
  );
};

const TagItem = styled.div<{ $isActive: boolean, $isEditMode: boolean }>`
  width: fit-content;
  border-bottom: 1px dotted
    ${({ $isActive, theme }) => ($isActive ? theme.colors.color_Gray_03 : 'transparent')};
  color: ${({ $isActive, theme }) => ($isActive ? theme.colors.color_Gray_03 : theme.colors.color_Gray_04)};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.5)};
  &:hover {
    ${({ $isEditMode }) => $isEditMode ? 'transform: scale(0.95);' : ''}
  }
  transition: all 0.3s ease-in-out;
  cursor: ${({ $isEditMode }) => $isEditMode ? 'pointer' : 'default'};
`;

export default WorkTagInViewer;
